function Halal() {
    return(
        <div>
        <h1>Halal Category</h1>
        <img
      src={require("../../assets/images/lontong.jpg")}
      alt="lontong"
    /> <br/>
    <img
      src={require("../../assets/images/nasilemak.jpg")}
      alt="nasilemak"
    />
        </div>
    )

}
export default Halal;